<div class="content-section implementation">
  <div class="row" ng-if="loadOnTreeLastF5Timestamp != undefined">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-note pull-bottom">
      <p style="text-align: right">
        Last Updated on
        {{ loadOnTreeLastF5Timestamp | date: 'dd MMMM yyyy HH:mm:ss' }}
      </p>
    </div>
  </div>
  <p-organizationChart
    [value]="loadONTreeData"
    selectionMode="single"
    [(selection)]="selectedNode"
    (onNodeSelect)="onNodeSelect($event)"
    styleClass="company"
  >
    <ng-template let-node pTemplate="person">
      <div style="margin-top: 1rem">
        <div class="pull-left">
          <div class="node_title">{{ node.label }}</div>
          <img
            class="img_node"
            src="{{ baseUrl }}{{ node.data.nodeImg.renderUrl }}"
            *ngIf="node.data.nodeImg !== undefined"
            width="32"
            alt="node image"
          />
        </div>
        <div class="pull-right status_data">
          <div>Power (kW)</div>

          <div>
            <span
              class="label label_tab_inverterView label-machine-power"
              style="color: #fff"
              >{{ getNodePower(node.data) | number: '1.2' }}</span
            >
          </div>
          <div>Connection Status</div>
          <div>
            <span
              class="label label_tab_inverterView"
              [ngClass]="getNodeClass(node.data)"
              >{{ getNodeStatus(node.data) }}</span
            >
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template let-node pTemplate="nodeLevel2">
      <div class="pull-left">
        <div class="node_title">{{ node.label }}</div>
        <img
          class="img_node"
          src="{{ baseUrl }}{{ node.data.nodeImg.renderUrl }}"
          *ngIf="node.data.nodeImg !== undefined"
          width="32"
          alt="node image"
        />
      </div>
      <div class="pull-right status_data">
        <div>Power (kW)</div>
        <div>
          <span
            class="label label_tab_inverterView label-machine-power"
            style="color: #fff"
            >{{ getNodePower(node.data) | number: '1.2' }}
          </span>
        </div>
        <div>Connection Status</div>
        <div>
          <span
            class="label label_tab_inverterView"
            [ngClass]="getNodeClass(node.data)"
            >{{ getNodeStatus(node.data) }}</span
          >
        </div>
      </div>
    </ng-template>

    <ng-template let-node pTemplate="nodeLevel3">
      <div class="pull-left">
        <div class="node_title">{{ node.label }}</div>
        <img
          class="img_node"
          src="{{ baseUrl }}{{ node.data.nodeImg.renderUrl }}"
          *ngIf="node.data.nodeImg !== undefined"
          width="32"
          alt="node image"
        />
      </div>
      <div class="pull-right status_data">
        <div>Power (kW)</div>
        <div>
          <span
            class="label label_tab_inverterView label-machine-power"
            style="color: #fff"
            >{{ getInverterPower(node.data) | number: '1.2' }}
          </span>
        </div>
        <div>AC Out</div>
        <div>
          <span
            class="label label_tab_inverterView"
            [ngClass]="getNodeACOutClass(node.data)"
            >{{ getNodeACOutStatus(node.data) }}</span
          >
        </div>
        <div>PV In (kW)</div>

        <div>
          <span
            class="label label_tab_inverterView label-machine-power"
            style="color: #fff"
            >{{ getNodeDCPower(node.data) | number: '1.2' }}
          </span>
        </div>
        <div>Inverter status</div>

        <div>
          <span
            class="label label_tab_inverterView"
            [ngClass]="getInverterFault(node.data)"
            >{{ getInverterFaultStatus(node.data) }}</span
          >
        </div>
      </div>
    </ng-template>
  </p-organizationChart>
</div>
